'use strict';

angular.module('sharecrf.news', [
    'ngCookies',
]);
